module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-splash page"
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('img', {
    staticClass: "page-splash__logo",
    attrs: {
      "src": require("../../assets/images/logo.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12-sm"
  }, [_c('p', [_vm._v("Er zijn ruim 50.000 hybride docenten in Nederland. Zij combineren het docentschap met een andere baan, binnen of buiten het onderwijs. Lijkt jou dat ook wat? Vul dan deze tool in en krijg een beeld van hoe een hybride carrière er voor jou uit kan zien!")]), _vm._v(" "), _c('p', {
    staticClass: "page-splash__meer-uitleg"
  }, [_vm._v("Wil je eerst meer uitleg over hybride docenten?"), _c('br'), _vm._v("\n                        Klik dan "), _c('span', {
    staticClass: "page-splash__hier-btn",
    on: {
      "click": _vm.uitlegHandler
    }
  }, [_vm._v("hier")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-splash__scroll-hint"
  }, [_c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ef308d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-splash.vue
// module id = 143
// module chunks = 0